import { createSelector } from 'reselect';

const selectGlobal = (state) => state.global;

export const selectCurrentPath = createSelector(
  [selectGlobal],
  (global) => global.currentPath
);

export const selectSidebarHidden = createSelector(
  [selectGlobal],
  (global) => global.sidebarHidden
);

export const selectCurrentCustomerInformation = createSelector(
  [selectGlobal],
  (global) => global.currentCustomerInformation
);

export const selectIsAuthenticated = createSelector(
  [selectGlobal],
  (global) => global.isAuthenticated
);

export const selectUserInformation = createSelector(
  [selectGlobal],
  (global) => ({ ...global.user, ...global.isAuthenticated })
);
